// extracted by mini-css-extract-plugin
module.exports = {"header":"Component-pepxcite_header__5OJOF","info":"Component-pepxcite_info__r72gD"};